import { postJson } from 'utils/http/postJson';

import type { CmsApiReactionContext } from './types/CmsApiReactionContext';
import type { CmsApiReactionType } from './types/CmsApiReactionType';

export async function cmsApiCreateReaction(
  pageId: string,
  reactionType: CmsApiReactionType,
): Promise<CmsApiReactionContext> {
  return postJson<CmsApiReactionContext>(
    `/data/website/reactions/cms-pages/${pageId}`,
    { reactionType },
  );
}
